const Images = {

    /**
     * @NetWork Icons
     */
    icon_logo100: 'https://wap.ys141319.com/img_logo_100.png',

    /**
     * @TabBar Icons
     */
    icon_tabbar_cart: require('./tabbar/icon_tabbar_cart.png'),
    icon_tabbar_home: require('./tabbar/icon_tabbar_home.png'),
    icon_tabbar_mine: require('./tabbar/icon_tabbar_mine.png'),
    icon_tabbar_shop: require('./tabbar/icon_tabbar_shop.png'),
    icon_tabbar_order: require('./tabbar/icon_tabbar_order.png'),
    icon_tabbar_shop1: require('./tabbar/icon_tabbar_shop1.png'),
    icon_tabbar_course: require('./tabbar/icon_tabbar_course.png'),
    icon_tabbar_home_center: require('./tabbar/icon_tabbar_home_center.png'),

    icon_tabbar_cart_cur: require('./tabbar/icon_tabbar_cart_cur.png'),
    icon_tabbar_home_cur: require('./tabbar/icon_tabbar_home_cur.png'),
    icon_tabbar_mine_cur: require('./tabbar/icon_tabbar_mine_cur.png'),
    icon_tabbar_shop_cur: require('./tabbar/icon_tabbar_shop_cur.png'),
    icon_tabbar_order_cur: require('./tabbar/icon_tabbar_order_cur.png'),
    icon_tabbar_shop1_cur: require('./tabbar/icon_tabbar_shop1_cur.png'),
    icon_tabbar_course_cur: require('./tabbar/icon_tabbar_course_cur.png'),



    /**
     * @Common [通用]
     */
    icon_add_pic: require('./icon/icon_add_pic.png'),
    icon_add_png: require('./icon/icon_add_png.png'),
    icon_add_text: require('./icon/icon_add_text.png'),
    icon_add_title: require('./icon/icon_add_title.png'),
    icon_add_video: require('./icon/icon_add_video.png'),
    icon_add: require('./icon/icon_add.png'),
    icon_address: require('./icon/icon_address.png'),
    icon_alipay: require('./icon/icon_alipay.png'),
    icon_amount_record: require('./icon/icon_amount_record.png'),
    icon_area: require('./icon/icon_area.png'),
    icon_arrow_bottom_blue: require('./icon/icon_arrow_bottom_blue.png'),
    icon_arrow_down_black: require('./icon/icon_arrow_down_black.png'),
    icon_arrow_down_blue: require('./icon/icon_arrow_down_blue.png'),
    icon_arrow_down: require('./icon/icon_arrow_down.png'),
    icon_arrow_left: require('./icon/icon_arrow_left.png'),
    icon_arrow_right1: require('./icon/icon_arrow_right1.png'),
    icon_arrow_right2: require('./icon/icon_arrow_right2.png'),
    icon_arrow_right3: require('./icon/icon_arrow_right3.png'),
    icon_arrow_top_blue: require('./icon/icon_arrow_top_blue.png'),
    icon_arrow_top: require('./icon/icon_arrow_top.png'),
    icon_arrow_up_blue: require('./icon/icon_arrow_up_blue.png'),
    icon_circle_down: require('./icon/icon_circle_down.png'),
    icon_circle_refresh: require('./icon/icon_circle_refresh.png'),
    icon_circle_up: require('./icon/icon_circle_up.png'),
    icon_close: require('./icon/icon_close.png'),
    icon_bill: require('./icon/icon_bill.png'),
    icon_btn_checkin: require('./icon/icon_btn_checkin.png'),
    icon_camara: require('./icon/icon_camara.png'),
    icon_camera: require('./icon/icon_camera.png'),
    icon_cart: require('./icon/icon_cart.png'),
    icon_check: require('./icon/icon_check.png'),
    icon_comment_blue: require('./icon/icon_comment_blue.png'),
    icon_comment: require('./icon/icon_comment.png'),
    icon_del_red: require('./icon/icon_del_red.png'),
    icon_edit: require('./icon/icon_edit.png'),
    icon_eyes: require('./icon/icon_eyes.png'),
    icon_fenxiang: require('./icon/icon_fenxiang.png'),
    icon_finish: require('./icon/icon_finish.png'),
    icon_good: require('./icon/icon_good.png'),
    icon_home_list_logo1: require('./icon/icon_home_list_logo1.png'),
    icon_home_list_logo2: require('./icon/icon_home_list_logo2.png'),
    icon_home_list_logo3: require('./icon/icon_home_list_logo3.png'),
    icon_home_list_logo4: require('./icon/icon_home_list_logo4.png'),
    icon_home_nav_logo1: require('./icon/icon_home_nav_logo1.png'),
    icon_home_nav_logo2: require('./icon/icon_home_nav_logo2.png'),
    icon_home_nav_logo3: require('./icon/icon_home_nav_logo3.png'),
    icon_home_nav_logo4: require('./icon/icon_home_nav_logo4.png'),
    icon_home: require('./icon/icon_home.png'),
    icon_image: require('./icon/icon_image.png'),
    icon_idcard: require('./icon/icon_idcard.png'),
    icon_location_white: require('./icon/icon_location_white.png'),
    icon_login_add: require('./icon/icon_login_add.png'),
    icon_login_code: require('./icon/icon_login_code.png'),
    icon_login_password: require('./icon/icon_login_password.png'),
    icon_login_phone: require('./icon/icon_login_phone.png'),
    icon_login_user: require('./icon/icon_login_user.png'),
    icon_logo: require('./icon/icon_logo.png'),
    icon_message: require('./icon/icon_message.png'),
    icon_mine_logo1_1: require('./icon/icon_mine_logo1_1.png'),
    icon_mine_logo1_2: require('./icon/icon_mine_logo1_2.png'),
    icon_mine_logo1_3: require('./icon/icon_mine_logo1_3.png'),
    icon_mine_logo1_4: require('./icon/icon_mine_logo1_4.png'),
    icon_mine_logo1_5: require('./icon/icon_mine_logo1_5.png'),
    icon_mine_logo1_6: require('./icon/icon_mine_logo1_6.png'),
    icon_mine_logo1_7: require('./icon/icon_mine_logo1_7.png'),
    icon_mine_logo1_8: require('./icon/icon_mine_logo1_8.png'),
    icon_mine_logo2_1: require('./icon/icon_mine_logo2_1.png'),
    icon_mine_logo2_2: require('./icon/icon_mine_logo2_2.png'),
    icon_mine_logo2_3: require('./icon/icon_mine_logo2_3.png'),
    icon_mine_logo2_4: require('./icon/icon_mine_logo2_4.png'),
    icon_mine_logo3_1: require('./icon/icon_mine_logo3_1.png'),
    icon_mine_logo3_2: require('./icon/icon_mine_logo3_2.png'),
    icon_mine_logo3_3: require('./icon/icon_mine_logo3_3.png'),
    icon_mine_logo3_4: require('./icon/icon_mine_logo3_4.png'),
    icon_mine_logo3_5: require('./icon/icon_mine_logo3_5.png'),
    icon_mine_logo3_6: require('./icon/icon_mine_logo3_6.png'),
    icon_mine_logo3_7: require('./icon/icon_mine_logo3_7.png'),
    icon_mine_logo4_1: require('./icon/icon_mine_logo4_1.png'),
    icon_mine_logo4_2: require('./icon/icon_mine_logo4_2.png'),
    icon_mine_logo4_3: require('./icon/icon_mine_logo4_3.png'),
    icon_mine_logo4_4: require('./icon/icon_mine_logo4_4.png'),
    icon_mine_logo4_5: require('./icon/icon_mine_logo4_5.png'),
    icon_mine_logo4_6: require('./icon/icon_mine_logo4_6.png'),
    icon_nav: require('./icon/icon_nav.png'),
    icon_people: require('./icon/icon_people.png'),
    icon_play: require('./icon/icon_play.png'),
    icon_qrcode_bg: require('./icon/icon_qrcode_bg.png'),
    icon_read: require('./icon/icon_read.png'),
    icon_recommend: require('./icon/icon_recommend.png'),
    icon_reduce: require('./icon/icon_reduce.png'),
    icon_refresh: require('./icon/icon_refresh.png'),
    icon_refund: require('./icon/icon_refund.png'),
    icon_salon_inheritor: require('./icon/icon_salon_inheritor.png'),
    icon_screen: require('./icon/icon_screen.png'),
    icon_search: require('./icon/icon_search.png'),
    icon_service: require('./icon/icon_service.png'),
    icon_share_blue: require('./icon/icon_share_blue.png'),
    icon_share: require('./icon/icon_share.png'),
    icon_sign: require('./icon/icon_sign.png'),
    icon_small_change: require('./icon/icon_small_change.png'),
    icon_stress: require('./icon/icon_stress.png'),
    icon_time: require('./icon/icon_time.png'),
    icon_transport: require('./icon/icon_transport.png'),
    icon_user_nav_1: require('./icon/icon_user_nav_1.png'),
    icon_user_nav_2: require('./icon/icon_user_nav_2.png'),
    icon_user_nav_3: require('./icon/icon_user_nav_3.png'),
    icon_user_nav_4: require('./icon/icon_user_nav_4.png'),
    icon_user_status1: require('./icon/icon_user_status1.png'),
    icon_user_status2: require('./icon/icon_user_status2.png'),
    icon_user_white: require('./icon/icon_user_white.png'),
    icon_video: require('./icon/icon_video.png'),
    icon_voice: require('./icon/icon_voice.png'),
    icon_wallet_yellow: require('./icon/icon_wallet_yellow.png'),
    icon_wallet: require('./icon/icon_wallet.png'),
    icon_wechat: require('./icon/icon_wechat.png'),
    icon_zan_blue: require('./icon/icon_zan_blue.png'),
    icon_zan: require('./icon/icon_zan.png'),
    icon_arc_company: require('./icon/icon_arc_company.png'),
    icon_arc_mobile: require('./icon/icon_arc_mobile.png'),
    icon_my_points: require('./icon/icon_my_points.png'),
    icon_company: require('./icon/icon_company.png'),


    /**
     * @Images
     */
    img_bg_aboutus_contact: require('./img/img_bg_aboutus_contact.jpg'),
    img_bg_student: require('./img/img_bg_student.png'),
    img_bg_checkin: require('./img/img_bg_checkin.jpg'),
    img_about_us: require('./img/img_about_us.png'),
    img_avatar_default_pic: require('./img/img_avatar_default_pic.png'),
    img_avatar_default: require('./img/img_avatar_default.png'),
    img_bg_about_us: require('./img/img_bg_about_us.png'),
    img_bg_aboutus_title_text: require('./img/img_bg_aboutus_title_text.png'),
    img_bg_aboutus_title: require('./img/img_bg_aboutus_title.png'),
    img_btn_bg1: require('./img/img_btn_bg1.png'),
    img_calendar: require('./img/img_calendar.png'),
    img_checkin_banner: require('./img/img_checkin_banner.png'),
    img_home_list_banner1: require('./img/img_home_list_banner1.png'),
    img_home_list_banner2: require('./img/img_home_list_banner2.png'),
    img_home_list_banner3: require('./img/img_home_list_banner3.png'),
    img_home_list_banner4: require('./img/img_home_list_banner4.png'),
    img_notice: require('./img/img_notice.png'),
    img_page_bg1: require('./img/img_page_bg1.png'),
    img_page_bg2: require('./img/img_page_bg2.png'),
    img_question_banner: require('./img/img_question_banner.png'),
    img_salon_article: require('./img/img_salon_article.png'),
    img_service: require('./img/img_service.png'),
    img_showpopup: require('./img/img_showpopup.png'),
    img_type_tip: require('./img/img_type_tip.png'),
    img_share_prompt: require('./img/img_share_prompt.png'),
    img_bg_arc_agent: require('./img/img_bg_arc_agent.png'),

}

export default Images;